export enum AppSessionStorage {
  ICM_URL = "icmUrl",
  API_URL = "apiUrl",
  PLUGIN_DOMAIN = "pluginDomain",
  USER_API_TOKEN = "userApiToken",
  SIGN_OUT_URL = "signOutUrl",
  SEARCH_MASTER_DATA_CONTRACT_TYPE = "searchMasterDataContractType",
  SEARCH_MASTER_DATA_SYS_ID = "searchMasterDataSysId",
  VISIBLE_ATTRS_CONFIG_MASTER_DATA_CONTRACT_TYPE = "visibleAttrsConfigMasterDataContractType",
  VISIBLE_ATTRS_CONFIG_MASTER_DATA_SYS_ID = "visibleAttrsConfigMasterDataSysId",
  TENANT_ID = "msGraphTenantId",
  CLIENT_ID = "msGraphClientId",
  REDIRECT_URI = "msGraphRedirectUri",
  CATEGORY_TO_SET = "categoryToSet",
  MS_GRAPH_AUTH_URL = "msGraphAuthUrl",
  MS_GRAPH_FLAG = "EnableMSGraph",
  OAUTH_ENABLED = "OauthEnabled",
  MS_GRAPH_URL = "msGraphUrl",
}
